import { useEffect } from 'react';

export default function Privacy() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="legal">
            <div className="container">
                <h1>Privacy Policy – CloTech AI Pvt. Ltd.</h1>
                <p><strong>Effective Date:</strong> 18.09.2025<br /><strong>Last Updated:</strong> 18.09.2025</p>
                <p>CloTech AI Pvt. Ltd. (“CloTech AI”, “we”, “our”, “us”) values the trust you place in us. This Privacy Policy explains how we collect, use, store, and protect your information when you use our website (https://clotechai.com) and our CRM software and related services.</p>
                <hr />
                <h2>1. Information We Collect</h2>
                <p>We may collect the following types of information:</p>
                <ul>
                    <li>Personal Information: Name, email address, phone number, company name, billing information, etc.</li>
                    <li>Account Data: Login credentials, user preferences, and CRM configuration details.</li>
                    <li>Usage Data: Activity logs, interactions with CRM modules, support requests, browser type, IP address, and device information.</li>
                    <li>Communication Data: Emails, WhatsApp conversations, and messages sent via our CRM.</li>
                    <li>Payment Data: Processed securely via third-party payment gateways; we do not store full card details.</li>
                </ul>
                <hr />
                <h2>2. How We Use Your Information</h2>
                <p>We use your information to:</p>
                <ul>
                    <li>Provide, operate, and maintain our CRM services.</li>
                    <li>Manage user accounts, authentication, and security.</li>
                    <li>Deliver customer support and respond to queries.</li>
                    <li>Improve our CRM by analyzing usage and feedback.</li>
                    <li>Send service updates, invoices, notifications, or marketing communications (if you have opted in).</li>
                    <li>Ensure compliance with legal, financial, and regulatory obligations.</li>
                </ul>
                <hr />
                <h2>3. Data Sharing & Disclosure</h2>
                <p>We do not sell or rent your personal information. We may share limited data only in these cases:</p>
                <ul>
                    <li>With Service Providers: Trusted third-party vendors (hosting, email, SMS, WhatsApp integration, payment processing).</li>
                    <li>For Compliance: If required by law, regulation, or valid legal process.</li>
                    <li>For Business Transfers: In case of merger, acquisition, or asset sale.</li>
                </ul>
                <hr />
                <h2>4. Data Security</h2>
                <ul>
                    <li>All customer data is stored on secure servers with encryption.</li>
                    <li>Access control, role-based permissions, and multi-factor authentication are enforced.</li>
                    <li>Regular backups and monitoring protect against data loss or breaches.</li>
                </ul>
                <hr />
                <h2>5. Data Retention</h2>
                <ul>
                    <li>Data is retained for as long as necessary to provide our services or comply with legal requirements.</li>
                    <li>Customers can request deletion of their data by contacting our support team.</li>
                </ul>
                <hr />
                <h2>6. Cookies & Tracking</h2>
                <ul>
                    <li>We use cookies and similar technologies to improve website performance and user experience.</li>
                    <li>You can manage or disable cookies through your browser settings.</li>
                </ul>
                <hr />
                <h2>7. Your Rights</h2>
                <p>As a user, you have the right to:</p>
                <ul>
                    <li>Access, correct, or update your personal information.</li>
                    <li>Request deletion of your data (subject to legal/business requirements).</li>
                    <li>Opt out of non-essential communications.</li>
                </ul>
                <hr />
                <h2>8. Third-Party Integrations</h2>
                <ul>
                    <li>Our CRM integrates with third-party services (Email, SMS, WhatsApp, APIs).</li>
                    <li>Data shared with these services follows their privacy policies, and we encourage users to review them separately.</li>
                </ul>
                <hr />
                <h2>9. Children’s Privacy</h2>
                <p>Our services are intended for businesses and not for children under 18. We do not knowingly collect data from minors.</p>
                <hr />
                <h2>10. Changes to This Policy</h2>
                <p>We may update this Privacy Policy periodically. Changes will be posted on our website with the updated effective date.</p>
                <hr />
                <h2>11. Contact &amp; Communication Address</h2>

                <p>
                    For any questions or concerns regarding these Terms, please <a href="/contact">contact us</a>.
                </p>
            </div>
        </div>
    );
}